export const OPERATIONAL_TRANSFER_PRICING_ROUTE = '/operational-transfer-pricing';

export const getTransferPricingRoute = (subPath?: string) =>
    subPath ? `${OPERATIONAL_TRANSFER_PRICING_ROUTE}/${subPath}` : OPERATIONAL_TRANSFER_PRICING_ROUTE;

